import { load as loadAnalyticsAdminSettings } from '@ms/yammer-data/dist/domains/analyticsAdminSettings/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

type UseLoadAnalyticsAdminSettings = () => void;
export const useLoadAnalyticsAdminSettings: UseLoadAnalyticsAdminSettings = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadAnalyticsAdminSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
